import { render, staticRenderFns } from "./activity-icons.vue?vue&type=template&id=596c149b&scoped=true&"
import script from "./activity-icons.vue?vue&type=script&lang=js&"
export * from "./activity-icons.vue?vue&type=script&lang=js&"
import style0 from "./activity-icons.vue?vue&type=style&index=0&id=596c149b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c149b",
  null
  
)

export default component.exports